import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stations: [],
  isStationsLoading: false,
  allUnits: [],
  isAllUnitsLoading: false,
  stationUnits: [],
  isStationUnitsLoading: false,
  selectedStationForUnits: null,
  stationsStatesEnum: null,
  isStationsStatesEnumLoading: false,
  unitsTypesEnum: null,
  isUnitsTypesEnumLoading: false,
};

export const StationAndUnitsReducer = createSlice({
  name: 'StationAndUnitsReducer',
  initialState,
  reducers: {
    setStations: (state, action) => {
      state.stations = action.payload;
    },
    isStationsLoading: (state, action) => {
      state.isStationsLoading = action.payload;
    },
    // All units actions
    setAllUnits: (state, action) => {
      state.allUnits = action.payload;
    },
    isAllUnitsLoading: (state, action) => {
      state.isAllUnitsLoading = action.payload;
    },
    // Station-specific units actions
    setStationUnits: (state, action) => {
      state.stationUnits = action.payload;
    },
    isStationUnitsLoading: (state, action) => {
      state.isStationUnitsLoading = action.payload;
    },
    setSelectedStationForUnits: (state, action) => {
      state.selectedStationForUnits = action.payload;
    },
    setStationsStates: (state, action) => {
      state.stationsStatesEnum = action.payload;
    },
    isStationsStatesLoading: (state, action) => {
      state.isStationsStatesEnumLoading = action.payload;
    },
    setUnitsTypes: (state, action) => {
      state.unitsTypesEnum = action.payload;
    },
    isUnitsTypesLoading: (state, action) => {
      state.isUnitsTypesEnumLoading = action.payload;
    },
  },
});

export const {
  setStations,
  isStationsLoading,
  setAllUnits,
  isAllUnitsLoading,
  setStationUnits,
  isStationUnitsLoading,
  setSelectedStationForUnits,
  setStationsStates,
  isStationsStatesLoading,
  setUnitsTypes,
  isUnitsTypesLoading,
} = StationAndUnitsReducer.actions;

export default StationAndUnitsReducer.reducer;
